import { render, staticRenderFns } from "./edit-ticket.vue?vue&type=template&id=6165d4e8&"
import script from "./edit-ticket.vue?vue&type=script&lang=js&"
export * from "./edit-ticket.vue?vue&type=script&lang=js&"
import style0 from "./edit-ticket.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports